Queue = require 'promise-queue'
Queue.configure require('bluebird')



// WEBPACK FOOTER //
// ./app/scripts/entry/configure-promise-queue.coffee